import { Fragment } from 'react';

import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

import type { TBreadcrumb } from '@/services/schema-service';

export type BreadcrumbProps = { items: TBreadcrumb[] };

const JobCategoryBreadcrumb = (props: BreadcrumbProps) => {
  return (
    <ul className='mb-8 flex flex-wrap items-center gap-x-2'>
      {props.items.map((item, index) => {
        return (
          <Fragment key={`${item.path}|${item.title}`}>
            <BreadcrumbItem {...item} />
            {index < props.items.length - 1 && <BreadcrumbDivider />}
          </Fragment>
        );
      })}
    </ul>
  );
};

const BreadcrumbItem = (props: TBreadcrumb) => {
  return (
    <li>
      <Link href={props.path || '#'} variant={LinkVariant.LINK}>
        <Typography.TextSmall className='text-typography-dark'>
          {props.title}
        </Typography.TextSmall>
      </Link>
    </li>
  );
};

const BreadcrumbDivider = () => {
  return <li>&gt;</li>;
};

export default JobCategoryBreadcrumb;
